import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LangContext";
import { SOURCE_LABELS } from "@/i18n";
import { useStatuses } from "@/context/StatusContext";
import { slaInfo } from "@/lib/format";
import { StatCard } from "@/components/common/StatCard";

export function ModOverview({ onOpenReports }) {
  const { lang } = useLang();
  const { label: stLabel, closes } = useStatuses();
  const [reports, setReports] = useState([]);
  const [cats, setCats] = useState({});
  const [sla, setSla] = useState({ default_hours: 24, categories: {} });

  useEffect(() => {
    api.get("/mod/reports").then((r) => setReports(r.data));
    api.get("/categories").then((r) => { const m = {}; r.data.forEach((c) => (m[c.key] = c)); setCats(m); });
    api.get("/sla").then((r) => setSla(r.data)).catch(() => {});
  }, []);

  const count = (s) => reports.filter((r) => r.status === s).length;
  const hoursFor = (cat) => sla.categories?.[cat] || sla.default_hours || 24;
  const breached = reports.filter((r) => slaInfo(r.created_at, r.status, hoursFor(r.category), closes(r.status)).overdue).length;
  const resolvedCount = reports.filter((r) => closes(r.status)).length;
  const catLabel = (k) => cats[k]?.[lang] || cats[k]?.en || k;

  return (
    <div>
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-5">
        <StatCard testId="ov-total" label="Total reports" value={reports.length} hint="All submissions" />
        <StatCard testId="ov-received" label={stLabel("received", lang)} value={count("received")} hint="Awaiting triage" />
        <StatCard testId="ov-review" label={stLabel("under_review", lang)} value={count("under_review")} hint="In progress" />
        <StatCard testId="ov-resolved" label="Resolved" value={resolvedCount} hint="Closed cases" />
        <StatCard testId="ov-sla" label="SLA breached" value={breached} hint="Open past deadline" trend={breached > 0 ? "!" : null} trendDir={breached > 0 ? "up" : "down"} />
      </div>

      <div className="mt-5 overflow-hidden rounded-lg border border-zinc-800/70 bg-[#111113]">
        <div className="flex items-center justify-between border-b border-zinc-800/70 px-4 py-2.5">
          <span className="label-caps">Recent reports</span>
          <button onClick={onOpenReports} className="text-[12px] text-blue-400 hover:text-blue-300">View all →</button>
        </div>
        <table className="w-full text-left">
          <thead>
            <tr className="border-b border-zinc-800/70 text-[10px] uppercase tracking-wider text-zinc-500">
              <th className="px-4 py-2 font-semibold">Reference</th>
              <th className="px-4 py-2 font-semibold">Platform</th>
              <th className="hidden px-4 py-2 font-semibold sm:table-cell">Category</th>
              <th className="hidden px-4 py-2 font-semibold sm:table-cell">Source</th>
              <th className="px-4 py-2 font-semibold">Status</th>
            </tr>
          </thead>
          <tbody>
            {reports.slice(0, 8).map((r) => (
              <tr key={r.reference} className="border-b border-zinc-800/50 text-[13px] last:border-0">
                <td className="px-4 py-2.5 font-mono text-zinc-200">{r.reference}</td>
                <td className="px-4 py-2.5 text-zinc-300">{r.platform}</td>
                <td className="hidden px-4 py-2.5 text-zinc-400 sm:table-cell">{catLabel(r.category)}</td>
                <td className="hidden px-4 py-2.5 text-zinc-400 sm:table-cell">{SOURCE_LABELS[lang][r.source] || r.source}</td>
                <td className="px-4 py-2.5 text-zinc-300">{stLabel(r.status, lang)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
